<template>
  <!--tool_company-->
    <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>企业资讯</p>
      <div class="design_box article-box">
        <div class="infomation-body" v-if="property.list.length!==0">
          <div class="infomation-list" v-for="(item, index) in property.list" :key="index">
            <div class="infomation-list-l">
              <div class="infomation-list-l-title">
                {{item.title}}
              </div>
              <div class="infomation-list-l-time">
                {{item.create_time}}
              </div>
            </div>
            <div class="infomation-list-r"
                 :style="{'background':'url('+(item.pic?item.pic:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png')+') repeat scroll center center / cover'}">
            </div>
          </div>
          <div class="infomation-more">
            查看更多
          </div>
        </div>
        <div class="infomation-body" v-else>
          <div class="infomation-list">
            <div class="infomation-list-l">
              <div class="infomation-list-l-title">
                企业资讯标题
              </div>
              <div class="infomation-list-l-time">
                发布时间
              </div>
            </div>
            <div class="infomation-list-r"
                 style="background:url(https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png) repeat scroll center center / cover;">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {};
    }
  };
</script>



